import { render } from "./Viewer.vue?vue&type=template&id=68125d06&scoped=true&ts=true"
import script from "./Viewer.vue?vue&type=script&lang=ts"
export * from "./Viewer.vue?vue&type=script&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=68125d06&lang=scss&scoped=true"
import "./Viewer.vue?vue&type=style&index=1&id=68125d06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68125d06"]])

export default __exports__